import React from 'react';
import Checkbox from '../../../../components/ui/Checkbox';

const AVAILABLE_ACTIONS = [
    { id: 'contacts.create', label: 'Criar Contato', category: 'Contatos' },
    { id: 'contacts.update', label: 'Atualizar Contato', category: 'Contatos' },
    { id: 'contacts.delete', label: 'Excluir Contato', category: 'Contatos' },
    { id: 'leads.create', label: 'Criar Negociação', category: 'Negociações' },
    { id: 'leads.update', label: 'Atualizar Negociação', category: 'Negociações' },
    { id: 'leads.delete', label: 'Excluir Negociação', category: 'Negociações' },
    { id: 'leads.move_stage', label: 'Mover de Etapa', category: 'Negociações' },
    { id: 'leads.win', label: 'Marcar como Ganho', category: 'Negociações' },
    { id: 'leads.lose', label: 'Marcar como Perdido', category: 'Negociações' },
    { id: 'leads.reopen', label: 'Reabrir Negociação', category: 'Negociações' },
];

const actionsByCategory = AVAILABLE_ACTIONS.reduce((acc, action) => {
    if (!acc[action.category]) acc[action.category] = [];
    acc[action.category].push(action);
    return acc;
}, {} as Record<string, typeof AVAILABLE_ACTIONS>);

interface ActionsSelectorProps {
    selectedActions: string[];
    onToggleAction: (actionId: string) => void;
}

const ActionsSelector: React.FC<ActionsSelectorProps> = ({ selectedActions, onToggleAction }) => (
    <div className="input-wrap">
        <div className="input-label">Ações Permitidas</div>
        <div className="max-h-48 overflow-y-auto rounded-lg border border-border bg-background custom-scrollbar">
            {Object.entries(actionsByCategory).map(([category, actions]) => (
                <div key={category} className="border-b border-border last:border-b-0">
                    <div className="bg-surface-subtle px-3 py-2 text-xs font-medium uppercase text-muted">
                        {category}
                    </div>
                    <div className="space-y-1 p-2">
                        {actions.map((action) => (
                            <Checkbox
                                key={action.id}
                                id={`action-${action.id}`}
                                label={action.label}
                                checked={selectedActions.includes(action.id)}
                                onChange={() => onToggleAction(action.id)}
                                checkboxSize="sm"
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default ActionsSelector;
